var chunkMapping = {
	"117": [
		341,
		17726
	],
	"137": [
		341,
		14190,
		16531,
		17726,
		19652,
		27755,
		54576,
		90819,
		96450
	],
	"468": [
		341,
		16531,
		17726,
		19652,
		54576,
		90819,
		96450
	],
	"657": [
		341,
		17726,
		96450
	],
	"705": [
		341,
		16531,
		17726,
		19652,
		54576,
		90819,
		96450
	],
	"813": [
		341,
		17726
	]
};
var idToExternalAndNameMapping = {
	"341": [
		"default",
		"./AuthenticationProvider",
		12887
	],
	"14190": [
		"default",
		"./AlertBanner",
		12887
	],
	"16531": [
		"default",
		"./ConversationTimeline",
		83941
	],
	"17726": [
		"default",
		"./Logger",
		12887
	],
	"19652": [
		"default",
		"./ConversationWrapperService",
		83941
	],
	"27755": [
		"default",
		"./AlertBannerContainer",
		12887
	],
	"54576": [
		"default",
		"./ConversationClientProvider",
		83941
	],
	"90819": [
		"default",
		"./MessageBox",
		83941
	],
	"96450": [
		"default",
		"./AuthorizationProvider",
		12887
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}